// src/App.js
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from "react-router-dom";
import TermsOfUse from './components/TermsOfUse';
import LoadingScreen from "./components/LoadingScreen";
import Navbar from "./components/Navbar";
import TopBar from "./components/Topbars";
import HomePage from "./components/Homepage";
import Payments from "./components/Payments";
import Vaniyar from "./components/Vaniyar";
import Login from "./components/Login"; // Make sure to create this component

// ✅ Protected Route Component
const ProtectedRoute = ({ isAuthenticated, children }) => {
  if (!isAuthenticated) {
    return <Navigate to="/admin-login" replace />;
  }
  return children;
};

// Layout Wrapper
const LayoutWrapper = ({ children }) => {
  const location = useLocation();

  // ✅ Hide Navbar & TopBar for Admin, Login, and sub-routes
  const shouldHide = 
    location.pathname.startsWith("/admin") || 
    location.pathname.startsWith("/admin-login");

  return (
    <>
      {!shouldHide && <TopBar />}
      {!shouldHide && <Navbar />}
      {children}
    </>
  );
};

function App() {
  const [loadingFinished, setLoadingFinished] = useState(false);
  
  // ✅ Auth State: Check localStorage so it persists after refresh
  const [isAuthenticated, setIsAuthenticated] = useState(
    localStorage.getItem("isAuth") === "true"
  );

  return (
    <>
      {!loadingFinished ? (
        <LoadingScreen onFinish={() => setLoadingFinished(true)} />
      ) : (
        <Router>
          <LayoutWrapper>
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<HomePage />} />
              <Route path="/payment" element={<Payments />} />

              {/* ✅ Admin Login Route */}
              <Route 
                path="/admin-login" 
                element={<Login setIsAuthenticated={setIsAuthenticated} />} 
              />

              {/* ✅ Protected Admin Page (Vaniyar) */}
              <Route 
                path="/admin" 
                element={
                  <ProtectedRoute isAuthenticated={isAuthenticated}>
                    <Vaniyar />
                  </ProtectedRoute>
                } 
              />
              
              {/* Redirect any unknown admin path to login */}
              <Route path="/admin/*" element={<Navigate to="/admin-login" />} />
              
            </Routes>
          </LayoutWrapper>
        </Router>
      )}
    </>
  );
}

export default App;